export const toKriptownAddKycDocumentInput = (files: File[]): KriptownAddKycDocumentInput => ({
  documents: files,
  type: 'IDENTITY_PROOF',
});

export interface KriptownAddKycDocumentInput {
  documents: File[];
  type: 'IDENTITY_PROOF';
}
